import * as z from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  exactCharacters: (num) => `Deve conter ${num} caracteres`,
};

const ProductionValidator = {
  title: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) }),
  // description: z
  //   .string({ message: messages.requiredField })
  //   .min(25, { message: messages.minCharacters(5) })
  //   .max(255, {
  //     message: messages.maxCharacters(255),
  //   }),
  idealization: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  art_direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  cast: z.string({ message: messages.requiredField }).optional().nullable(),
  music: z.string({ message: messages.requiredField }).optional().nullable(),
  start_at: z.string().nullable().optional(),
  finish_at: z.string().nullable().optional(),
  dramaturgy: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  musical_direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  lightining: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  enactment: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  production_direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  associate_producer: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  realization: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  ticket_link: z
    .string({ message: messages.requiredField })
    .url({ message: "Link inválido" })
    .optional()
    .or(z.literal("")),
  cenary: z.string({ message: messages.requiredField }).optional().nullable(),
  costumes: z.string({ message: messages.requiredField }).optional().nullable(),
  original: z.string({ message: messages.requiredField }).optional().nullable(),
  argument: z.string({ message: messages.requiredField }).optional().nullable(),
  text: z.string({ message: messages.requiredField }).optional().nullable(),
  production_coordination: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  audiovisual_direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  adaptation: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  artistic_collaboration: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  premiere_location: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  movement_direction: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  coreography: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  light_designer: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  sound_designer: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  research: z.string({ message: messages.requiredField }).optional().nullable(),
  cast_production: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  active_start_at: z.string().nullable().optional(),
  active_finish_at: z.string().nullable().optional(),
  vimeo_link: z
    .string({ message: messages.requiredField })
    .url({ message: "Link inválido" })
    .optional()
    .or(z.literal("")),
  location: z.string({ message: messages.requiredField }).optional().nullable(),
  state: z.string({ message: messages.requiredField }).optional().nullable(),
  city: z.string({ message: messages.requiredField }).optional().nullable(),
  season_dates: z
    .string({ message: messages.requiredField })
    .optional()
    .nullable(),
  // date_start_at: z.string().nullable().optional(),
  // date_finish_at: z.string().nullable().optional(),
  time: z.string({ message: messages.requiredField }).optional().nullable(),
};

export default ProductionValidator;
